import { FloatCell } from "./FloatCell";
import { useCallback } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export function MoneyFloatCell(props) { var propsChange = props.onChange; var onChange = useCallback(function (value, other) { propsChange(value * 100, other); }, [propsChange]); return /*#__PURE__*/ _jsx(FloatCell, { value: ensurePrecision(props.value / 100, 2), onCancel: props.onCancel, onChange: onChange }); }
export function ensurePrecision(value, n) { var toFixed = value.toFixed(n); var toString = value.toString(); if (toFixed.length > toString.length)
    return toFixed; return toString; }
